import React from 'react';
import { Badge, ButtonBase, Typography } from '@mui/material';
import { useBlockingCallback } from '../../../../hooks/useBlockingCallback';
import styles from './SideNavButtonItem.module.scss';
import classNames from 'classnames';
import { CustomMenuButtonItemType } from '../../CustomListItem/CustomListItemComponent';

export const SideNavButtonItem: React.FC<{
	listItem: CustomMenuButtonItemType;
	badgeContent?: number;
}> = ( {
	listItem: { label, icon, isActive = false, onClick, className },
	badgeContent,
}: {
	listItem: CustomMenuButtonItemType;
	badgeContent?: number;
} ) => {
	const blockedOnClick = useBlockingCallback( onClick );
	return (
		<Badge
			badgeContent={ badgeContent }
			color='primary'
			className={ classNames( styles.badge, {
				[ styles.badgeActive ]: isActive,
			} ) }
		>
			<ButtonBase
				onClick={ blockedOnClick }
				className={ classNames(
					styles.button,
					{ [ styles.buttonActive ]: isActive },
					className
				) }
			>
				{ icon }
				{ label ? <Typography>{ label }</Typography> : null }
			</ButtonBase>
		</Badge>
	);
};
